function Form() {
  return (
    <>
      <form action="https://api.web3forms.com/submit" method="POST">
        <input type="hidden" name="access_key" value="d237c666-479d-4e78-be42-ea0f74e0cdcf" />
        <div className="labeDisplay">
          <label>Nom</label>
          <input placeholder type="text" required />
        </div>
        <div className="labeDisplay">
          <label>Email</label>
          <input placeholder type="email" required />
        </div>
        <div className="labeDisplay">
          <label>Message</label>
          <textarea required></textarea>
        </div>
        <input className="submit" type="submit" />
      </form>
    </>
  );
}

export default Form;
